/* ---------------------------------- Types --------------------------------- */

/**
 * FieldType
 *
 * Different input field types supported
 */
export type FieldType =
    | 'text'
    | 'email'
    | 'password'
    | 'newPassword'
    | 'confirmPassword'
    | 'number'
    | 'year'
    | 'checkbox'
    | 'dropdown';

/* --------------------------------- Helpers -------------------------------- */

/**
 * getHTMLInputType
 *
 * Returns the correct input type for all system types, e.g. passwords
 *
 * @param fieldType FieldType
 * @param label The default value used if no system field type exists
 * @returns
 */
export const getHTMLInputType = (type: string): string => {
    switch (type) {
        case 'newPassword':
        case 'confirmPassword':
            return 'password';
        default:
            return type;
    }
};
